import { MONITOR_ENV } from "@/constants/env";

export default function setup() {
  if (!MONITOR_ENV) return;

  const head = document.createElement("script");
  head.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P6GDPC5');`;

  const body = document.createElement("iframe");
  body.setAttribute(
    "src",
    "https://www.googletagmanager.com/ns.html?id=GTM-P6GDPC5"
  );
  body.setAttribute("height", 0);
  body.setAttribute("width", 0);
  body.setAttribute("style", "display:none;visibility:hidden");

  document.head.appendChild(head);
  document.body.appendChild(body);
}
